import { AnimatePresence, motion } from 'motion/react';
import { useApp } from '@/store';

export function Toasts() {
  const toasts = useApp(s => s.toasts);
  return (
    <div className="fixed bottom-5 right-5 left-5 sm:left-auto z-[100] flex flex-col gap-2 pb-[env(safe-area-inset-bottom)]">
      <AnimatePresence>
        {toasts.map(t => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="rounded-lg bg-foreground px-4 py-2.5 text-sm text-background shadow-xl"
          >
            {t.msg}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
